import {useAntCharts} from "../../../modules/Charts/Ant/useAntCharts";
import React, {useMemo} from "react";
import {Heatmap} from "@ant-design/plots";
import {Card, Col, Divider, Row} from "antd";
import BarTable from "../../../charts/BarTable";
import SectorIndustryChart from "../../../components/Charts/SectorIndustryChart";
import NivoDonut from "../../../modules/Charts/Nivo/NivoDonut";
import {CATEGORICAL_COLORS} from "../../../utils/colorUtils";

const CompositeMetrics = ({composite, title})=>{
    const toPercent = (v)=>{
        try{
            return parseFloat((v*100).toFixed(2));
        }
        catch(e){
            return 0;
        }
    }
    const size = composite?.size || [];
    const style = composite?.style || [];
    const sectors = composite?.sector_gic?.map(({k, v})=>({label:k, value:toPercent(v)}));
    const bondCategories = composite?.bond_categories?.map(({k, v})=>({label:k, value:toPercent(v)}));
    const combinedSectorsAndBondCategories = Array.isArray(sectors) ? [...sectors.filter(x=>x.value>0)] : [];
    if (Array.isArray(bondCategories) && bondCategories.length > 0) {
        combinedSectorsAndBondCategories.push(...[...bondCategories.filter(x=>x.value>0)])
    }
    const industries = composite?.industry_gic?.map(({k, v})=>({label:k, value:toPercent(v)}));
    const netAssets = composite?.net_assets?.map((obj, index) => ({
      id: obj.k,
      value: toPercent(obj.v),
      color: CATEGORICAL_COLORS[index % CATEGORICAL_COLORS.length]
    }));
    return (
        <Card bordered={false}>
            <Row justify={'center'}>
                {netAssets && (
                    <div style={{height: 400, width: '100%'}}>
                        <NivoDonut data={netAssets} centerText={title} />

                    </div>
                )}

                <Divider />
                <SectorIndustryChart sectors={sectors?.reduce((acc, curr)=>{acc[curr.label] = curr.value*0.01; return acc}, {}) || {}}
                                     industries={industries?.reduce((acc, curr)=>{acc[curr.label] = curr.value*0.01; return acc}, {}) || {}}
                                     height={350}

                />
                {combinedSectorsAndBondCategories && <BarTable data={combinedSectorsAndBondCategories} title={'Sectors'}  normalize={true} />}
            </Row>
        </Card>
    )
}


const CompositionView = ({portfolio, benchmark})=>{
    return (
        <Row justify={'center'} gutter={[64, 64]} className={'px-6'}>
            <Col xs={24} xl={12}>
                <CompositeMetrics composite={portfolio?.composite} title={'Portfolio'} />
            </Col>
            {benchmark && benchmark.hasOwnProperty('composite') && (
                <Col xs={24} xl={12}>
                    <CompositeMetrics composite={benchmark?.composite} title={benchmark.name} />
                </Col>

            )}
        </Row>
    )
}


export default CompositionView;